<app-icon-and-button-card cardTitle="Consultation Sent Successfully!" iconClass="fa fa-check-circle">
  <p class="has-text-centered m-4">
    Thank you for your prescription request. A physician will review your test results and create a personalized
    treatment plan, which will be sent to your secure portal. We will notify you as soon as it is ready. This treatment
    plan will include detailed information about the prescription the clinician has sent to your chosen pharmacy.
  </p>
</app-icon-and-button-card>
